const steps = [
  "Ticket",
  "AI-assisted build",
  "Human review",
  "Staging",
  "QA",
  "Pull request",
  "Deployment",
];

const HowWeWork = () => {
  return (
    <section className="about-how">
      <div className="about-how-content containerFull">
        <div className="how-headline">
          <h2>How we work.</h2>
          <p>
            Our delivery process is built around control. We do not simply
            prompt AI and push code. Work moves through a structured flow:
          </p>
        </div>

        <div className="how-process-row">
          {steps.map((step, i) => (
            <div className="how-step" key={step}>
              <span className="how-step-label">{step}</span>
              {i < steps.length - 1 && (
                <span className="how-arrow" aria-hidden="true">
                  &rarr;
                </span>
              )}
            </div>
          ))}
        </div>

        <p className="how-support">
          This allows us to use AI where it helps, while keeping engineers
          responsible for the decisions, testing, and production safety.
        </p>
      </div>
    </section>
  );
};

export default HowWeWork;
